import { IAuthenticationContext, Authentication, Provider, ESocialType } from '@cian/authentication-widget';
import * as React from 'react';
import { useStore } from 'react-redux';

import { AuthenticationLayout } from '../../components/AuthenticationLayout';
import { useApplicationContext } from '../../utils/applicationContext';
import { init } from './utils/AuthContext';

export function AuthenticationContainer() {
  const disabledSocials = Object.values(ESocialType);
  const context = useApplicationContext();
  const store = useStore();
  const [authContext, setAuthContext] = React.useState<IAuthenticationContext | null>(null);

  React.useEffect(() => {
    const authCtx = init(context, store);
    authCtx.init();
    setAuthContext(authCtx.context);
  }, [context, store]);

  if (!authContext) {
    return null;
  }

  return (
    <AuthenticationLayout>
      <Provider context={authContext}>
        <Authentication disabledSocials={disabledSocials} logger={context.logger} />
      </Provider>
    </AuthenticationLayout>
  );
}
